import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

export const TOOLTIP_CONFIG: Partial<NgbTooltipConfig> = {
  container: 'body',
  // Open Triggers : Close Triggers
  triggers: 'mouseenter:mouseleave click',
};
